// extracted by mini-css-extract-plugin
module.exports = {"btn":"zxu+u","google":"H8Je4","apple":"pm78V","btn-content":"z014J","pseudoApple":"sDlzs"};